import { useContext } from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import {
  Button, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import useServiceProduct from '@hooks/useServiceProduct'

import EntitySelector from '@components/EntitySelector'

const defaultState = {
  selectedProductId: null,
}

const CreateCompatibleProductModal = (props) => {
  const { callbacks, modalKey = 'CreateCompatibleProductModal', showModal } = props
  const { closeModal, updateServiceProduct } = callbacks

  const [state, setState] = useSetState(defaultState)
  const { selectedProductId } = state

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { serviceProduct } = modalPayload

  const {
    callbacks: {
      toggleCompatibleProduct,
    },
    compatibleProductIds,
    updating,
  } = useServiceProduct(serviceProduct)

  const productAlreadyAdded = compatibleProductIds.includes(selectedProductId)
  const saveEnabled = selectedProductId && !productAlreadyAdded

  const updateProductPayload = {
    callbacks: {
      action: toggleCompatibleProduct,
      afterAction: closeModal,
    },
    entityParams: selectedProductId,
    toastText: 'Compatible Product Added',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Add Compatible" titleSecondLine="Product" />

      <SidebarModal.Content>
        <EntitySelector
          callbacks={{
            selectItem: product => setState({ selectedProductId: product ? product.id : null }),
          }}
          endpoint="service_products"
          entityKey="serviceProducts"
          errorMessage={productAlreadyAdded ? 'Already Added' : null}
          label="* Add Compatible Product"
          selectedItemId={selectedProductId}
          showEntityId
        />
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          onClick={() => updateServiceProduct(updateProductPayload)}
          size="large"
        >
          {saveEnabled ? 'Add Product' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

CreateCompatibleProductModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <CreateCompatibleProductModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
